module.exports = __webpack_public_path__ + "static/media/IMG-7.4bdf4860.jpg";